import { render, staticRenderFns } from "./DialogEdit.vue?vue&type=template&id=581bd2fc&scoped=true"
import script from "./DialogEdit.js?vue&type=script&lang=js&external"
export * from "./DialogEdit.js?vue&type=script&lang=js&external"
import style0 from "./DialogEdit.vue?vue&type=style&index=0&id=581bd2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bd2fc",
  null
  
)

export default component.exports